import { useQuery } from "@tanstack/react-query";
import { dashboard, invoices } from "../services/api";
import type { DashboardStats, Invoice } from "../types";

/**
 * TanStack Query hook for fetching dashboard statistics.
 * Refetches every 60 seconds so the dashboard stays reasonably fresh.
 */
export function useDashboardStats() {
  return useQuery<DashboardStats>({
    queryKey: ["dashboard", "stats"],
    queryFn: () => dashboard.getStats(),
    refetchInterval: 60_000,
  });
}

/**
 * TanStack Query hook for fetching the most recent invoices.
 * Used by the "Recent Uploads" table on the dashboard.
 */
export function useRecentInvoices() {
  return useQuery<{ invoices: Invoice[]; last_key?: string }>({
    queryKey: ["invoices", "recent"],
    queryFn: () => invoices.list(),
  });
}
